var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProtocolHomescreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 58 58",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3 2.306L15.493 2.306C11.288 2.312 7.881 5.719 7.874 9.924L7.874 40.8C3.692 41.258 0.672 45.018 1.128 49.201C1.551 53.076 4.832 56.007 8.731 55.991L36.272 55.991C40.477 55.985 43.884 52.578 43.89 48.373L43.89 17.541L49.3 17.541C53.508 17.541 56.918 14.13 56.918 9.923C56.918 5.716 53.508 2.306 49.3 2.306Z",
    fill: "#d388ff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.875 53.736L8.731 53.736C5.766 53.736 3.361 51.333 3.361 48.368C3.361 45.401 5.765 42.998 8.731 42.998L30.875 42.998C27.916 45.966 27.916 50.769 30.875 53.736Z",
    fill: "#d388ff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.648 9.923L41.648 48.373C41.648 51.336 39.247 53.736 36.284 53.736C33.322 53.736 30.92 51.336 30.92 48.373C30.92 45.41 33.322 43.01 36.284 43.01C36.906 43.01 37.411 42.505 37.411 41.883C37.411 41.26 36.906 40.755 36.284 40.755L10.174 40.755L10.174 9.923C10.18 6.98 12.551 4.59 15.493 4.559L43.857 4.559C42.44 5.984 41.646 7.913 41.648 9.923Z",
    fill: "#d388ff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.173 15.288L43.902 15.288L43.902 13.439L48.173 13.439L48.173 15.288Z",
    fill: "#d388ff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.427 15.174L50.427 15.163L50.427 12.312C50.427 11.689 49.923 11.185 49.3 11.185L43.902 11.185L43.902 9.923C43.911 6.96 46.318 4.565 49.281 4.573C52.244 4.58 54.639 6.989 54.631 9.951C54.624 12.462 52.877 14.631 50.427 15.174Z",
    fill: "#d388ff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.963 13.484L17.476 13.484C16.853 13.484 16.349 13.988 16.349 14.61C16.349 15.233 16.853 15.737 17.476 15.737L33.963 15.737C34.585 15.737 35.09 15.233 35.09 14.61C35.09 13.989 34.585 13.484 33.963 13.484Z",
    fill: "#000000",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.963 21.53L17.476 21.53C16.853 21.53 16.349 22.035 16.349 22.656C16.349 23.279 16.853 23.783 17.476 23.783L33.963 23.783C34.585 23.783 35.09 23.278 35.09 22.656C35.09 22.035 34.585 21.53 33.963 21.53Z",
    fill: "#000000",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.963 29.576L17.476 29.576C16.853 29.576 16.349 30.081 16.349 30.703C16.349 31.325 16.853 31.83 17.476 31.83L33.963 31.83C34.585 31.83 35.09 31.325 35.09 30.703C35.09 30.081 34.585 29.576 33.963 29.576Z",
    fill: "#000000",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.3 2.306L15.493 2.306C11.288 2.312 7.881 5.719 7.874 9.924L7.874 40.8C3.692 41.258 0.672 45.018 1.128 49.201C1.551 53.076 4.832 56.007 8.731 55.991L36.272 55.991C40.477 55.985 43.884 52.578 43.89 48.373L43.89 17.541L49.3 17.541C53.508 17.541 56.918 14.13 56.918 9.923C56.918 5.716 53.508 2.306 49.3 2.306ZM30.875 53.736L8.731 53.736C5.766 53.736 3.361 51.333 3.361 48.368C3.361 45.401 5.765 42.998 8.731 42.998L30.875 42.998C27.916 45.966 27.916 50.769 30.875 53.736ZM41.648 9.923L41.648 48.373C41.648 51.336 39.247 53.736 36.284 53.736C33.322 53.736 30.92 51.336 30.92 48.373C30.92 45.41 33.322 43.01 36.284 43.01C36.906 43.01 37.411 42.505 37.411 41.883C37.411 41.26 36.906 40.755 36.284 40.755L10.174 40.755L10.174 9.923C10.18 6.98 12.551 4.59 15.493 4.559L43.857 4.559C42.44 5.984 41.646 7.913 41.648 9.923ZM48.173 15.288L43.902 15.288L43.902 13.439L48.173 13.439L48.173 15.288ZM50.427 15.174L50.427 15.163L50.427 12.312C50.427 11.689 49.923 11.185 49.3 11.185L43.902 11.185L43.902 9.923C43.911 6.96 46.318 4.565 49.281 4.573C52.244 4.58 54.639 6.989 54.631 9.951C54.624 12.462 52.877 14.631 50.427 15.174Z",
    fill: "#000000",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtocolHomescreen);
export default __webpack_public_path__ + "static/media/icon_protocol_homescreen.cffb2bfe4b8d7879a395c6bf7147e9f5.svg";
export { ForwardRef as ReactComponent };